import { render, staticRenderFns } from "./PhoneForm.vue?vue&type=template&id=33cba066&"
import script from "./PhoneForm.vue?vue&type=script&lang=ts&"
export * from "./PhoneForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports